import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.common.white,
    background: 'linear-gradient(to bottom, #4096ff, #1677ff)',
    '&:hover': {
      background: 'linear-gradient(to bottom, #1677ff, #0958d9)'
    }
  }
}))

interface PropTypes {
  onClick?: () => void
  icon: string
  text: string
}

const BattleFieldNextButton: React.FC<PropTypes> = (props) => {
  const { icon, onClick, text } = props
  const classes = useStyles()
  return (
    <Button
      classes={classes}
      onClick={onClick}
    >
      <img src={icon} alt="chat" />
      {text}
    </Button>
  )
}

export default React.memo(BattleFieldNextButton)
